import { parseISO } from 'date-fns/parseISO';

import { formatDateNonlocalised } from '../../../../bootstrap/localisation';

import type { DateData } from '../../selectors/types';

// Gets sum of medians from flexible dates service
// from between checkin and checkout dates
export default function getSelectedMedianIndicativePrice(
  checkInDate: Date,
  checkOutDate: Date,
  dateData?: DateData,
) {
  if (dateData) {
    const formattedCheckInDate = formatDateNonlocalised(checkInDate);
    const formattedCheckOutDate = formatDateNonlocalised(checkOutDate);

    if (dateData[formattedCheckInDate] && dateData[formattedCheckOutDate]) {
      const entityDateDataKeys = Object.keys(dateData).sort(
        (a, b) => parseISO(a).getTime() - parseISO(b).getTime(),
      );
      const selectedDates = entityDateDataKeys.slice(
        entityDateDataKeys.indexOf(formattedCheckInDate),
        entityDateDataKeys.indexOf(formattedCheckOutDate),
      );
      const selectedMedianIndicativePrice = selectedDates
        .map((singleDate) => dateData[singleDate].medianPrice)
        .reduce((prev, curr) => prev + curr, 0);

      return selectedMedianIndicativePrice;
    }
  }

  return null;
}
